import { FC } from "react";
import { DimsAndWeightModal } from "crossdock/modes/inspection/crossdock-dims-and-weight/modals/DimsAndWeightModal";
import { DimsAndWeightCompleteSessionModal } from "crossdock/modes/inspection/crossdock-dims-and-weight/modals/DimsAndWeightCompleteSessionModal";

export const dimsAndWeightModalMap: Record<DimsAndWeightModal, FC<any>> = {
  [DimsAndWeightModal.COMPLETE_SESSION_MODAL]: DimsAndWeightCompleteSessionModal,
};
